import translations from './graphite.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/graphite'

export const graphite: Metal = {
  id: 9,
  slug: 'graphite',
  name: t.name,
  symbol: 'C',
  // The sheet's five pins replace the earlier placeholder set: Luobei rather than the
  // Heilongjiang basin around it, Ruangwa rather than the Mahenge project inside it, and
  // Fotadrevo and Itabela in place of the Canadian pin the sheet drops. No operators —
  // the sheet names none. Coordinates are the towns the sheet names, not the pit heads.
  mines: [
    {
      name: 'Balama (Mozambique)',
      region: 'Balama',
      coordinates: [38.58, -13.33],
    },
    {
      name: 'Luobei (China)',
      region: 'Luobei',
      coordinates: [130.85, 47.6],
    },
    {
      name: 'Ruangwa (Tanzania)',
      region: 'Ruangwa',
      coordinates: [38.7, -10.03],
    },
    {
      name: 'Fotadrevo (Madagascar)',
      region: 'Fotadrevo',
      coordinates: [45.03, -24.05],
    },
    {
      name: 'Itabela (Brazil)',
      region: 'Itabela',
      coordinates: [-39.55, -16.57],
    },
  ],
  countries: [
    { name: 'China', percent: 79.1 },
    { name: 'Mozambique', percent: 6.4 },
    { name: 'Brazil', percent: 4.3 },
    { name: 'Madagascar', percent: 4.1 },
    { name: 'India', percent: 1.7 },
  ],
  important: true,
  // No `related`: the sheet's Related Metal row is blank. Its copy leans on lithium
  // throughout ("lithium gets all the attention"), so a graphite/lithium pair looks
  // intended, but it is not authored — see the note in the handover.
  video: {
    name: 'graphite',
    poster: '/mine-my-phone/images/posters/graphite.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 4,
      quantityLabel: t.smartphone.label,
      parts: ['battery'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Michael Robinson Chavez',
        },
      ],
      secondBento: [
        {
          src: `${dir}/04.jpg`,
          orientation: 'vertical',
          credit: 'Michael Robinson Chavez',
        },
        {
          src: `${dir}/05.jpg`,
          orientation: 'vertical',
          credit: 'Michael Robinson Chavez',
        },
      ],
    },
  },
}
